import React, { useContext, useEffect, useState } from 'react'
import { XMLParser } from 'fast-xml-parser';
import { PodcastAllOptionsContext } from '../context/PodcastAllOptionsContext'
import Sport1 from '../assets/Sports1.png'
import Sport2 from '../assets/Sports2.png'
import Sport3 from '../assets/Sports3.png'
import shift from '../assets/shift.mp3'
import Sport4 from '../assets/Sports4.png'
import { NavbarContext } from '../context/NavbarContext'
import { AiFillLike } from "react-icons/ai";
import { AiFillDislike } from "react-icons/ai";
import { MdOutlinePlayCircleOutline } from "react-icons/md";
import { FiDownload } from "react-icons/fi";
import { BiSliderAlt } from "react-icons/bi";
import { RiReplay30Fill } from "react-icons/ri";
import { IoShareSocialOutline } from "react-icons/io5";
import { RiForward30Line } from "react-icons/ri";
import singlePodcast1 from '../assets/singlepodcast1.png'
import singlePodcast2 from '../assets/singlepodcast2.png'
import singlePodcast3 from '../assets/singlepodcast3.png'
import podcastEpisode from '../assets/podcastEpisode.png'
import AudioPlayer from './AudioPlayer'
import { ApiContext } from '../context/ApiContext'
import { useLocation, useNavigate } from 'react-router-dom';
import { getAppData } from '../apiService';
import { ShimmerCircularImage, ShimmerContentBlock, ShimmerText, ShimmerThumbnail } from 'react-shimmer-effects';


function PodcastAllOptionsInternal() {
  const navigate = useNavigate()
  const location = useLocation();
  const { navHeading, setNavHeading } = useContext(NavbarContext)
  const [loading, setLoading] = useState(true);
  const [audioLoading, setAudioLoading] = useState(false);
  const [error, setError] = useState(null);
  const [epNo, setEpNo] = useState(1)
  const { rss, image, Categories3_id, isPlayings, setIsPlayings, audiosRef, isPlayingOrNot, setIsPlayingOrNot, innerAudioRef, audioSrc, setAudioSrc, audioRef, togglePlayPause } = useContext(ApiContext);
  const [episodes, setEpisodes] = useState(null);

  const [audioUrls, setAudioUrls] = useState(null);


  // console.log(image);


  useEffect(() => {
    if (rss) {
      const fetchFeed = async () => {
        try {
          let response = await fetch(rss);
          // console.log(response, "here is response");

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const text = await response.text();
          const parser = new XMLParser({
            ignoreAttributes: false,
            attributeNamePrefix: "@_",
          });
          const jsonObj = parser.parse(text);
          const items = jsonObj.rss.channel.item || [];
          setEpisodes(items);
        } catch (error) {
          console.error('Error fetching the podcast feed directly:', error.message);
          navigate("/podcast")

          // Try using the proxy
          try {
            const proxyUrl = 'https://thingproxy.freeboard.io/fetch/';
            const response = await fetch(proxyUrl + rss);
            // console.log(response, "here is response with proxy");

            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }

            const text = await response.text();
            const parser = new XMLParser();
            const jsonObj = parser.parse(text);
            const items = jsonObj.rss.channel.item || [];
            setEpisodes(items);
            const heading = episodes[0]["itunes:title"].length > 55 ? episodes[0]["itunes:title"].substring(0, 57) + '...' : episodes[0]["itunes:title"];
            setNavHeading(heading)
            setAudioSrc(episodes[0]["enclosure"]["@_url"])
          } catch (proxyError) {
            console.error('Error fetching the podcast feed with proxy:', proxyError.message);
            setError('Error fetching data. Please try again later.');
            navigate("/podcast")
          }
        } finally {
          setLoading(false);
        }
      };

      fetchFeed();

    }

    else if (!rss) {
      navigate("/podcast");
      // console.log("i am also there", rss, "ma rss");
      // console.log("i am also there", Categories3_id, "ma Categories3_id");

    }
  }, [rss])


  useEffect(() => {
    if (episodes) {
      // console.log(episodes, "here are episodes");
      setAudioSrc(episodes[0]["enclosure"]["@_url"])
      const heading = episodes[0]["itunes:title"].length > 55 ? episodes[0]["itunes:title"].substring(0, 57) + '...' : episodes[0]["itunes:title"];
      setNavHeading(heading)
    }
    // else if (episodes1) {
    //   console.log(episodes1, "here are episodes1");
    //   const heading = episodes1.title.length > 55 ? episodes1.title.substring(0, 57) + '...' : episodes1.title;
    //   setNavHeading(heading)
    //   setAudioSrc(episodes1.file)
    // }
  }, [episodes]);


  const handleChangePlay = (guid, index) => {
    const item = episodes.find((item) => item.guid['#text'] == guid)
    if (navHeading == item["itunes:title"]) {
      if (isPlayings) {
        if (audioRef.current) {
          audioRef.current.pause();
          setIsPlayings(false)
        }
      }
      if (isPlayingOrNot) {
        if (innerAudioRef.current) {
          const audio = innerAudioRef.current
          audio.currentTime = 0;
          audio.oncanplaythrough = () => {
            // console.log("i am playing",innerAudioRef.current);
            audio.play().catch(error => {
              console.log('Error playing audio:', error);
            });
          }
        }

      } else if (!isPlayingOrNot) {
        togglePlayPause();
        // console.log("first i will");

      }
    } else {
      setNavHeading(item["itunes:title"])
      setAudioLoading(true)
      setEpNo(index + 1)

      const audios = item.enclosure["@_url"]
      if (audios) {
        setAudioSrc(audios)
        // setAudioLoading(false)
      }

      // const audio = new Audio(audioSrc);
      // audio.oncanplaythrough = () => {
      setAudioLoading(false);
      if (isPlayings) {
        if (audioRef.current) {
          audioRef.current.pause();
          setIsPlayings(false)
        }
      }
      if (isPlayingOrNot) {
        if (innerAudioRef.current) {
          const audio = innerAudioRef.current
          audio.oncanplaythrough = () => {
            // console.log("i am playing", innerAudioRef.current);
            audio.play().catch(error => {
              console.log('Error playing audio:', error);
            });
          }
        }

      } else if (!isPlayingOrNot) {
        togglePlayPause();
        // console.log("first i am am ");

      }
      // audiosRef.current.play();
      // console.log(audios,"item here here here here ");
      // };
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

  }

  const morePodcasts = [
    { id: "ojfewi1", image: `${singlePodcast2}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi2", image: `${singlePodcast3}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi3", image: `${singlePodcast3}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi4", image: `${singlePodcast3}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi5", image: `${singlePodcast3}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi6", image: `${singlePodcast3}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi7", image: `${singlePodcast3}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi8", image: `${singlePodcast3}`, heading: "Premium story", author: "James Hoyce" },
    { id: "ojfewi9", image: `${singlePodcast3}`, heading: "Premium story", author: "James Hoyce" },

  ]

  const podcastss = [
    { id: "gdfty1", image: `${podcastEpisode}`, heading: "Ep 1: Apps that matter Reselling Updates and News", time: "25.25 mins" },
    { id: "gdfty2", image: `${podcastEpisode}`, heading: "Ep 2: Apps that matter", time: "25.00 mins" },
    { id: "gdfty3", image: `${podcastEpisode}`, heading: "Ep 3: Apps that matter Reselling Updates and News Reselling Updates and News", time: "26.25 mins" },
    { id: "gdfty4", image: `${podcastEpisode}`, heading: "Ep 4: Apps that matter", time: "30.25 mins" },
  ]


  const myMorePodcastslength = Math.ceil(morePodcasts.length / 2)
  const allMoreProdcast1 = morePodcasts.slice(0, myMorePodcastslength)
  const allMoreProdcast2 = morePodcasts.slice(myMorePodcastslength, morePodcasts.length)
  // console.log(allMoreProdcast1);
  // console.log(allMoreProdcast2);


  if (loading) {
    return (
      <div className="layout2-div">
        <div className="podcast-internal-main-div">
          <div className='podcast-internal-center-div'>
            <div className='podcast-internal-bg-with-content-div'>
              <ShimmerThumbnail height={450} rounded />
            </div>
            <div className='podcast-internal-center-player'>
              <div className='audio-player'>
                <div className='flex justify-center mb-4'><ShimmerCircularImage size={55} /></div>
                <div className='flex justify-around items-center'>
                  <ShimmerCircularImage size={35} />
                  <ShimmerCircularImage size={35} />
                  <ShimmerCircularImage size={35} />
                  <ShimmerCircularImage size={35} />
                </div>
                <hr className='My-audio-payer-hr' />
                <div>
                  <ShimmerText line={1} gap={5} />
                </div>
              </div>
            </div>
          </div>
          <div className='podcast-internal-left-right-div-only-for-dasktop-and-laptop'>
            <p className='podast-internal-left-main-only-for-dasktop-and-laptop'>Episode </p>
            <div className='podcast-all-options-paras-and-image-outer-div-only-for-dasktop-and-laptop'>
              <div className='podcast-all-options-paras-and-image-only-for-dasktop-and-laptop-1234567'>
                <ShimmerContentBlock
                  title
                  text
                  cta
                  thumbnailWidth={170}
                  thumbnailHeight={170}
                  style={{ marginBottom: "10px" }}
                />
              </div>

              <div className='podcast-all-options-paras-and-image-only-for-dasktop-and-laptop-1234567'>
                <ShimmerContentBlock
                  title
                  text
                  cta
                  thumbnailWidth={170}
                  thumbnailHeight={170}
                  style={{ marginBottom: "10px" }}
                />
              </div>

              <div className='podcast-all-options-paras-and-image-only-for-dasktop-and-laptop-1234567'>
                <ShimmerContentBlock
                  title
                  text
                  cta
                  thumbnailWidth={170}
                  thumbnailHeight={170}
                  style={{ marginBottom: "10px" }}
                />
              </div>

            </div>
          </div>

        </div>
      </div>
    );
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }



  return (
    <div className='layout2-div'>
      {/* pod id : {singlePodcastId} */}
      <div className='podcast-internal-main-div'>

        {/* <div className='podcast-internal-left-side-div'> */}
        {/* <p className='podast-internal-left-main'>More Podcasts</p> */}
        {/* <hr className='podcast-internal-hr' /> */}
        {/* {morePodcasts.map((item) => ( */}
        {/* <div className='podcast-internal-left-side-internal' key={item.id}>  */}
        {/* <div className='podcast-internal-more-podcast-img-and-para'> */}
        {/* <img src={item.image} alt="singlepodcast" /> */}
        {/* <div className='podcast-internal-more-podcast-paras'> */}
        {/* <p className='podcast-internal-more-podcast-para1'>{item.heading}</p> */}
        {/* <p className='podcast-internal-more-podcast-para2'>{item.author}</p> */}
        {/* </div> */}
        {/* </div> */}
        {/* <hr className='podcast-internal-hr' /> */}
        {/* </div> */}
        {/* // ))} */}
        {/* </div> */}


        {audioLoading ? (
          <div className='podcast-internal-center-div'>
            <div className="loader-container">
              <div className="dot-wave-loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        ) : (<div className='podcast-internal-center-div'>
          {/* <div>
                        <img src={singlePodcast1} alt="singlepodcast" />
                    </div> */}
          <div className='podcast-internal-bg-with-content-div'
          // style={{ backgroundImage: `url(${image})` }}
          >
            <img src={image} alt="image" width={"100%"} height={"100%"} />
            {/* {episodes1?<img src={episodes1.image} alt={epNo} />:<img src={image} alt={epNo} />} */}
            {/* <button className='phone-btn-for-podcast-all-options-internal'>Todays Host</button>
                        <p className='podcast-internal-bg-para1'>Learn the amazing ways
                            to retain your old users.</p>
                            <button className='podcast-interbal-bg-btn'>Subscribe</button>
                            <div className='podcast-interbal-bg-icons-div'><AiFillLike /> <AiFillDislike /></div> */}
            <p className='podcast-internal-bg-para2'>EPISODE {epNo}</p>
          </div>
          <div className='podcast-internal-center-player'>
            <div className='podcast-internal-play-button'></div>
            {/* <div>
                            <p >1X</p>
                            <RiReplay30Fill />
                            <RiForward30Line />
                            <IoShareSocialOutline />
                        </div> */}
            {/* <div>
                    <audio controls src={shift}></audio>
                </div> */}
            <div className="">
              {/* {episodes1 ? (
                <AudioPlayer />
              ) : (
                <AudioPlayer />                                                              //pass data through context
              )} */}
              <AudioPlayer />
            </div>
          </div>
        </div>)}

        {episodes && episodes.length > 0 ? (
          <div className='podcast-internal-left-right-div-only-for-dasktop-and-laptop'>
            <p className='podast-internal-left-main-only-for-dasktop-and-laptop'>Episode {epNo} ({epNo}/{episodes.length})</p>
            <div className='podcast-all-options-paras-and-image-outer-div-only-for-dasktop-and-laptop'>
              {episodes.map((item, index) => (
                <div className='podcast-all-options-paras-and-image-only-for-dasktop-and-laptop-1234567' key={item.index} onClick={() => handleChangePlay(item.guid['#text'], index)}>
                  <div className='podcast-all-options-paras-and-image-only-for-dasktop-and-laptop' >
                    <div className='podcast-all-options-image-only-for-dasktop-and-laptop'>
                      <img src={image || item.image} alt="Podcast episode" style={{ width: "100%", height: "100%" }} />
                    </div>
                    <div className='podcast-all-options-paras-only-for-dasktop-and-laptop'>
                      <p className='podcast-all-options-para1-only-for-dasktop-and-laptop'>{item["itunes:title"].length > 55 ? item["itunes:title"].substring(0, 57) + '...' : item["itunes:title"]}</p>
                      <p className='podcast-all-options-para2-only-for-dasktop-and-laptop'>{item["itunes:duration"]}</p>
                      <div className='podcast-all-options-icons-only-for-dasktop-and-laptop'>
                        <MdOutlinePlayCircleOutline />
                        <FiDownload />
                        <BiSliderAlt />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className='podcast-internal-left-right-div-only-for-dasktop-and-laptop'>Data not found</div>
        )}



        {/* 
        <div className='podcast-internal-left-right-div'>
          <p className='podast-internal-left-main'>More Podcasts</p>
          <hr className='podcast-internal-hr' />
          <div className='podcast-all-options-paras-and-image'>
             {morePodcasts.map((item) => ( 
              <div className='podcast-internal-right-side-internal' key={item.id}>  
                <div className='podcast-internal-more-podcast-img-and-para'>
                  <img src={item.image} alt="singlepodcast" />
                  <div className='podcast-internal-more-podcast-paras'>
                    <p className='podcast-internal-more-podcast-para1'>{item.heading}</p>
                    <p className='podcast-internal-more-podcast-para2'>{item.author}</p>
                  </div>
                </div>
                <hr className='podcast-internal-hr' />
              </div>
            // ))}
          </div>
        </div> */}




        {/* <div className='podcast-internal-left-right-div-only-for-phone'> */}
        {/* <p className='podast-internal-left-main-only-for-phone'>More Podcasts</p> */}
        {/* <hr className='podcast-internal-hr-only-for-phone' /> */}
        {/* <div className='podcast-all-options-paras-and-image-only-for-phone'> */}
        {/* <div className='podcast-all-options-paras-and-image-only-for-phone1'> */}
        {/* {allMoreProdcast1.map((item) => ( */}
        {/* // <div className='podcast-internal-right-side-internal-only-for-phone' key={item.id}>   */}
        {/* <div className='podcast-internal-more-podcast-img-and-para-only-for-phone'> */}
        {/* <img src={item.image} alt="singlepodcast-only-for-phone" /> */}
        {/* <div className='podcast-internal-more-podcast-paras-only-for-phones'> */}
        {/* <p className='podcast-internal-more-podcast-para1-only-for-phone'>{item.heading}</p> */}
        {/* <p className='podcast-internal-more-podcast-para2-only-for-phone'>{item.author}</p> */}
        {/* </div> */}
        {/* </div> */}
        {/* <hr className='podcast-internal-hr' /> */}
        {/* </div> */}
        {/* // ))} */}
        {/* </div> */}

        {/* <div className='podcast-all-options-paras-and-image-only-for-phone2'> */}
        {/* {allMoreProdcast2.map((item) => ( */}
        {/* <> */}
        {/* <hr style={{borderLeft: "1px solid red",height: "35px",width: "1px"}}/> */}

        {/* <div className='podcast-internal-right-side-internal-only-for-phone' key={item.id}>   */}
        {/* <div className='podcast-internal-more-podcast-img-and-para-only-for-phone'> */}
        {/* <img src={item.image} alt="singlepodcast-only-for-phone" /> */}
        {/* <div className='podcast-internal-more-podcast-paras-only-for-phone'> */}
        {/* <p className='podcast-internal-more-podcast-para1-only-for-phone'>{item.heading}</p> */}
        {/* <p className='podcast-internal-more-podcast-para2-only-for-phone'>{item.author}</p> */}
        {/* </div> */}
        {/* </div> */}
        {/* <hr className='podcast-internal-hr' /> */}
        {/* </div> */}
        {/* </> */}
        {/* // ))} */}
        {/* </div> */}
        {/* </div> */}
        {/* </div> */}







      </div>
    </div>
  )
}

export default PodcastAllOptionsInternal